import { SpotList } from "Domain/Model/SpotList/SpotList";

export const FIND_SPOT_LISTS_SUCCESS = 'FIND_SPOT_LISTS_SUCCESS';

interface IFindSpotListsSuccess {
    spotLists: Record<string, SpotList>,
    request: {},
    response: {},
}

export const findSpotListsSuccess = ({ spotLists, request, response }: IFindSpotListsSuccess) => ({
    type: FIND_SPOT_LISTS_SUCCESS,
    payload: { spotLists },
    meta: {
        request,
        response,
    }
});
